import React from "react";
import "../HTMate/HTMate.scss";

const PrivacyAndPolicy = () => {
  return (
    <div className="textitem">
      <h3>Hlthtek.com Privacy Policy</h3>
      <p>
        <strong>Last Updated:</strong> 1st June 2024
      </p>

      <p>Welcome to Hlthtek.com!</p>

      <p>
        Hlthtek.com is committed to protecting your privacy and ensuring the
        security of your personal information. This Privacy Policy ("Policy")
        describes how we collect, use, disclose, and protect your information
        when you access and use our platform ("Platform").
      </p>

      <div className="textitem">
        <h5>Information We Collect:</h5>
        <p>
          We collect information that you provide directly to us, as well as
          information that is automatically collected when you use the Platform.
        </p>
        <ul>
          <li>
            <strong>Account Information:</strong> When you create an account, we
            collect your name, email address, password, and other contact
            information.
          </li>
          <li>
            <strong>Health Information:</strong> We collect health data, such as
            medical history, diagnoses, medications, allergies, and other
            relevant information that you or your authorized healthcare provider
            share with us. This data is securely stored and accessible only by
            authorized individuals with your consent.
          </li>
          <li>
            <strong>Billing Information:</strong> If you use our services that
            require payment, we may collect your billing information, such as
            credit card details. This information is securely processed through
            trusted payment gateways.
          </li>
        </ul>
      </div>

      <div className="textitem">
        <h5>Information We Collect Automatically:</h5>
        <ul>
          <li>
            <strong>Usage Data:</strong> We collect information about how you
            interact with the Platform, such as pages visited, features used,
            and time spent on the site. This data is used to improve our
            services and provide a better user experience.
          </li>
          <li>
            <strong>Device Information:</strong> We collect information about
            your device, such as operating system, device type, and unique
            device identifiers. This information is used to ensure compatibility
            and optimize the platform's performance.
          </li>
        </ul>
      </div>

      <div className="textitem">
        <h5>How We Use Your Information:</h5>
        <p>
          We use your information to provide and improve our services,
          communicate with you, and protect the security of our platform.
        </p>
        <ul>
          <li>
            <strong>Provide and Improve Services:</strong> We use your
            information to provide and personalize the services you request,
            including EHR access, health data interoperability, and predictive
            health tools. We also use this information to improve our platform,
            features, and services.
          </li>
          <li>
            <strong>Communication:</strong> We use your information to
            communicate with you about our services, updates, and important
            information.
          </li>
          <li>
            <strong>Security and Compliance:</strong> We use your information to
            protect the security of our platform, detect and prevent fraud, and
            comply with applicable laws and regulations.
          </li>
        </ul>
      </div>

      <div className="textitem">
        <h5>Sharing Your Information:</h5>
        <p>
          We may share your information with third-party service providers who
          assist us in providing our services, such as payment processors, data
          analytics providers, and customer support providers. These providers
          are required to protect your information in accordance with our
          instructions and our Privacy Policy.
        </p>
        <p>
          We may also disclose your information if required by law, regulation,
          or legal process, or if we believe that disclosure is necessary to
          protect the rights, property, or safety of Hlthtek.com, our users, or
          others.
        </p>
      </div>

      <div className="textitem">
        <h5>Your Choices:</h5>
        <ul>
          <li>
            <strong>Account Information:</strong> You can review and update your
            account information at any time.
          </li>
          <li>
            <strong>Health Information:</strong> You can control who has access
            to your health information and how it is used.
          </li>
          <li>
            <strong>Marketing Communications:</strong> You can opt out of
            receiving marketing communications from us.
          </li>
          <li>
            <strong>Cookies and Tracking Technologies:</strong> You can adjust
            your browser settings to refuse cookies or other tracking
            technologies.
          </li>
        </ul>
      </div>

      <div className="textitem">
        <h5>Security:</h5>
        <p>
          We take reasonable measures to protect your information from
          unauthorized access, disclosure, alteration, or destruction. However,
          no website or internet transmission is completely secure, and we
          cannot guarantee the security of your information.
        </p>
      </div>

      <div className="textitem">
        <h5>Children's Privacy:</h5>
        <p>
          The Platform is not intended for use by children under the age of 13.
          We do not knowingly collect personal information from children under
          the age of 13.
        </p>
      </div>

      <div className="textitem">
        <h5>Changes to this Policy:</h5>
        <p>
          We may update this Policy from time to time. We will post any changes
          on the Platform and will indicate the date the Policy was last
          updated. You are responsible for reviewing the Policy periodically.
        </p>
      </div>

      <div className="textitem">
        <h5>Contact Us:</h5>
        <p>
          If you have any questions about this Policy, please contact us at
          <a href="mailto:contactus@hlthtek.com">contactus@hlthtek.com</a>.
        </p>
      </div>

      <p>
        <strong>
          By accessing and using the Hlthtek.com platform, you agree to this
          Privacy Policy.
        </strong>
      </p>
      <p>
        <strong>
          This Privacy Policy is intended to be read in conjunction with our
          Terms and Conditions.
        </strong>
      </p>
    </div>
  );
};

export default PrivacyAndPolicy;
